(function ($, Global) {
    var urlParams = new UrlParams();
    var oneSignalAlreadyLoaded = false;
    initPage();

    $(document).ready(handlePageReady);

    $(document).on('CookieConsent', function (event, data) {
        handleCookieConsent.call(this, event, data)
    });

	$(document).on('click', function (e) {
        handlePopoverClicked.call(this, e);
    });

	$(document).on('click', '[data-href]', function (e) {
		e.preventDefault();
		var href = $(this).attr('data-href');

		Global.location.replace(href);
	});

	$(document).on('click', 'a[href^="#"]', function (e) {
        handleAnchorClicked.call(this, e)
    });

    $(document).on('click', '.form-group.has-feedback .input-password + .glyphicon', function () {
        handleInputPasswordClicked.call(this)
    });

    $(document).on('show.bs.collapse hide.bs.collapse', '.card', function (e) {
		toggleCard($(this));
	});

	$(document).on('click', '[data-redirect]', function () {
		Global.URL_REDIRECT = $(this).data('redirect');
	});

	$(document).on('click', '[data-access]', function () {
		Global.URL_REDIRECT_TYPE = $(this).data('access');
	});

	$(document).on("mousemove", function (event) {
		Global.mouseX = event.pageX;
		Global.mouseY = event.pageY;
    });

    $(document).on('click',
        '[data-message]',
        function (e) {
            var $target = $(this);
            var text = $target.data("text");
            var i18n = $target.data("i18n");
            var type = $target.data("type");
            var config = {
                dismissTimeout: $target.data("timeout") ? parseInt($target.data("timeout"), 10) : 0
            };

            if (i18n && window.i18n[i18n])
                text = window.i18n[i18n];

            if (!text)
                return;

            $.Topic('show-message').publish(text, type, config);
        });


	//Init prefilter Ajax pour protection anti CSRF
	$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
		var verificationToken = $("meta[name='__AjaxRequestVerificationToken']").attr('content');
		if (verificationToken) {
			jqXHR.setRequestHeader("X-Request-Verification-Token", verificationToken);
		}
    });

    function initPage() {
        if ($(Global) && $(Global).exists()) {
            $(Global).on('beforeunload', function () {
                Global.REFRESH = true;
            });

            $(Global).smartResize(function () {
                $('.sprite').resizeContainerSprite();
                $('[class*="grid-table"]').gridtable();
                $('.position.vcenter').vcenter();
                $('.position.center').center();
            });

            $(Global).on('load', function () {
                $('[class*="grid-table"]').gridtable();
                $('.position.vcenter').vcenter();
                $('.position.center').center();

                setTimeout(function () {
                    $('.sprite').resizeContainerSprite();
                }, 300);

            });
        }
    }

    function handlePageReady() {
        /**
         * Sentry - Récupération des appels ajax
         */
        $(document).ajaxStart(function () {
            var date = new Date();
            Global.AJAX_START = date.toJSON();
        });

        // récupération des erreurs Javascript
        $(document).ajaxError(function (event, jqXHR, ajaxSettings, thrownError) {
            var date = new Date();
            var sentryEventInfo = $.extend({}, jqXHR, ajaxSettings, {
                ajaxDateStart: Global.AJAX_START,
                ajaxDateError: date.toJSON(),
                responseTextB64: Global.btoa(unescape(encodeURIComponent(jqXHR.responseText))),
                responseTextLength: jqXHR.responseText && jqXHR.responseText.length
            });

            Global.Sentry.withScope(function (scope) {
                for (var k in sentryEventInfo) {
                    if (typeof sentryEventInfo[k] === "function") continue;

                    scope.setExtra(k, sentryEventInfo[k]);
                }
                Global.Sentry.captureMessage("Ajax " + (thrownError || jqXHR.statusText) + " sur  " + (jqXHR.url || ajaxSettings.url));
            });
        });
        /******* Sentry log **********/

        updateTitleByQueryString();

        handleScrollOnPageReady();

        var prevButton = '<span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none"><path d="M10.8301 1L0.830079 11L10.8301 21" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        var nextButton = '<span><svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none"><path d="M0.829956 21L10.83 11L0.829956 1" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

        $(document).ready(function () {
            $('.carousel-multi-items .owl-carousel').owlCarousel({
                loop: true,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                        loop: false,
                        dots: true
                    },
                    680: {
                        items: 2,
                        nav: false,
                        dots: true
                    },
                    1000: {
                        items: 3,
                        nav: true,
                        dots: true,
                        loop: false
                    }
                },
                navText: [prevButton, nextButton]
            });
        });

        if ($.touchscreen()) {
            $('body').addClass('touchscreen');
        }

        $('[data-toggle="navHorizontal"]').each(function () {
            initNavHorizontalComponent.call(this);
        });
        $('[data-toggle="visible"]').toggleVisible();

        $('.sprite').resizeContainerSprite();

        $('[type="checkbox"]:checked, [type="radio"]:checked').parent().addClass('check');

        //Popover init
        $('[data-toggle="popover"]').popover();

        $('[data-toggle="tooltip"]').tooltip();

        if ($('.modal-enabled').exists()) {
            $('.modal-enabled').modal('show');
        }

        //Adblocker hide social contents :(
        $('.social').attr('style', 'display: block !important');
        $('[class*="icon-social-"]').attr('style', 'display: inline-block !important');

        var $elParallax = $('.parallax-image');
        var parallaxSpeed = 0.5;

        window.onscroll = function () {
            $elParallax.each(function (idx, elem) {
                var speed = $(elem).closest(".parallax-section").data('parallax-speed') || parallaxSpeed;

                var dist = $(window).scrollTop() - $(elem).offset().top;
                $(elem).css('top', (dist * Number(speed) + 'px'))
            })
        }

        initScrollFix()

        //Vérification de demande de logout
        checkDemandeDeLogoutUrl();

        //Vérification et gestion des URL offre article
        checkArriveDepuisUrlOffrirArticle();

        //Demande affichage menu utilisateur dans le menu
        checkDemandeUserMenu();
    }
    function initNavHorizontalComponent() {
        try {
            new NavHorizontal($(this));
        } catch (err) {
            console.error(err)
        }
    }

    function initScrollFix() {
        // Polyfill pour le scroll du menu sur des vieux mobiles sous IOS
        var elem = document.querySelectorAll('.menuleft-scrollable');

        if (Global.ScrollFix) {
            try {
                new Global.ScrollFix(elem[0]);
            } catch (err) {
                console.error(err)
            }
        }
    }

    function handleScrollOnPageReady() {
        if ($.URLHash()) {
            scrollWhenUrlHash();
        } else {
            $(window).scrollTop(0);
        }
    }

    function handleCookieConsent(event, data) {
        var webPush = new WebPush();
        if (data.services.indexOf('oneSignal') >= 0 && !oneSignalAlreadyLoaded) {
            loadJs('https://cdn.onesignal.com/sdks/OneSignalSDK.js', function () {
                oneSignalAlreadyLoaded = true;
                
                webPush.initEvents();
            });
        }
        if (oneSignalAlreadyLoaded) {
            webPush.initEvents();
        }
    }

    function handlePopoverClicked(e) {
        var popoverId;
        var $target = $(e.target)
        var $popovers = $('.popover.in')

        if ($target.data('toggle') == 'popover') {
            popoverId = $target.attr('aria-describedby');
        }

        $popovers.not('#' + popoverId).each(function () {
            $('[aria-describedby="' + $(this)[0].id + '"]').trigger('click')
        })
    }

    function handleAnchorClicked(e) {
        e.preventDefault();

        var $this = $(this);
        var id = $this.attr("href");
        var toggle = $this.data('toggle');

        if (!toggle && id !== '#' && !$this.hasClass('no-scroll')) {
            var anchor;

            if (id.indexOf('/#') > -1) {
                anchor = id.slice(id.indexOf('/#') + 1);
            } else {
                anchor = id.slice(id.indexOf('#'));
            }

            if (!$(anchor).exists()) {
                Global.location.replace(id)
            } else {
                var scrollTop = $(anchor).offset().top + $('.nav-fixed').height();

                $('html, body').stop().animate({
                    scrollTop: scrollTop
                }, 'slow');
            }
        }
    }

    function handleInputPasswordClicked() {
        var $this = $(this);
        var $inputPassword = $this.parent().find('input.input-password');

        if ($this.hasClass('glyphicon-eye-open')) {
            $this.removeClass('glyphicon-eye-open').addClass('glyphicon-eye-close');
            $inputPassword.attr('type', 'text');
        } else {
            $this.removeClass('glyphicon-eye-close').addClass('glyphicon-eye-open');
            $inputPassword.attr('type', 'password');
        }
    }

    function loadJs(src, callback) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = "text/javascript";
        script.async = true;
        script.src = src;

        if (script.readyState) {  // only required for IE <9
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  //Others
            script.onload = function () {
                callback();
            };
            script.onerror = function () {
                Global.Sentry.captureMessage('Erreur lors du chargement du fichier js ' + src)
            }
        }

        head.appendChild(script);
    }

    function toggleCard($el) {
        var $heading = $el.find('.card-header');
		var $icon = $heading.find('.icon');
		var oppositeIcons = {
			'icon-1': 'icon-2',
			'icon-2': 'icon-1',
			'icon-5': 'icon-50',
			'icon-50': 'icon-5',
			'icon-21': 'icon-222',
			'icon-222': 'icon-21'
		}
		var oppositeIconKeys = Object.keys(oppositeIcons);

		$heading[$heading.hasClass('active') ? 'removeClass' : 'addClass']('active');

		if ($icon.exists()) {
			for (var i = 0; i < oppositeIconKeys.length; i++) {
				if ($icon.hasClass(oppositeIconKeys[i])) {
					$icon.replaceClass(oppositeIconKeys[i], oppositeIcons[oppositeIconKeys[i]]);
					break;
				}
			}
		}
	}

	function scrollWhenUrlHash() {
		var hash = $.URLHash();

		if (hash.indexOf('/') >= 0) return;

		if ($('#' + hash).exists()) {
			var $el = $('#' + hash);
			var $elOffsetTop = $el.offset().top;

			if ($el.hasClass('panel-collapse') && !$el.hasClass('in')) {
				$el.collapse();
				$elOffsetTop = $el.closest('.panel').offset().top;
			}
			$('html, body').animate({
				scrollTop: $elOffsetTop + $('.nav-fixed').height() + 30
			}, 'slow');
		}
	}

	function updateTitleByQueryString() {
		var params = urlParams.getParams();

		if (params.title) {
			var $templateTitle = $('script#' + params.title);

			if ($templateTitle.exists()) {
				var content = $templateTitle.html();
				var dataTarget = $templateTitle.data('target');
				var $target = $(dataTarget);

				if ($target.exists()) $target.html(content);
			}
		}
	}

    //Permet de vérifier si on demande explicitement un logout ( utiliser par les PMC)
    function checkDemandeDeLogoutUrl() {
        var paramLogout = urlParams.getParam('logout');

        if (paramLogout === "1") {
            var authmodel = new AuthModel();
            authmodel.logout();
        }
    }

    function checkArriveDepuisUrlOffrirArticle() {
        new OffrirArticleCatcher(new OffrirArticleModel()).initEvents();
    }

    function checkDemandeUserMenu() {
        var paramProfile = urlParams.getParam('profile');
        if (paramProfile !== '1') return;
        $('#header_bs_menu_user').parent().addClass('open');
        $('body, .menutop, .screen-backdrop').addClass('in')
    }

}(jQuery, window));